import { BriksioTenantMenu } from './OrganizationMenu';

import { useSelector } from 'third-party';

import { appSelectors } from 'selectors';

export const useMenu = () => {
  const selected = useSelector(appSelectors.selectedTenant);

  if (!selected) {
    // No org selected — show full menu structure with all links mocked to '#'
    return BriksioTenantMenu();
  }

  const org = {
    ...selected.tenant,
    description: selected.tenant.description ?? '',
    avatar: selected.tenant.avatar ?? '',
  };

  return BriksioTenantMenu(org);
};
